import React from 'react';
import { translate } from 'react-i18next';
import { Rating, Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

import SurveyButtons from './SurveyButtons.js';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, spacings} from 'style';
import inLogo from 'img/In-2C-48px-TM.png';
import LoadInline from 'modules/loading/LoadInline.js';

import styleDef from './style.js'
var style= {
    ...styleDef,
    buttonWrapper: {
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
    },
    syncIcon: {
        float: 'right',
        fontSize: '24px',
        lineHeight: '1',
        opacity: '1',
    },
    image: {
        marginTop: spacings.base,
        marginBottom: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        height:'300px', 
    },
    spacer: {
        height: '50px',
    },
};

const SurveyPageSyncContacts = ({t, surveyPage, busy, error, pluginsMap, onSkip, onSubmit, onConnect}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <div style={style.segment}>
                {busy && 
                    <LoadInline centered vcentered /> 
                }
                {!busy &&
                <form onSubmit={onSubmit} autoComplete='off'>
                    <div style={style.header}>{surveyPage.title}</div>

                    {Boolean(surveyPage.asset && surveyPage.asset.url) && 
                        <img alt='' style={style.image} src={surveyPage.asset.url} />
                    }

                    <div style={style.description}>
                        {Utils.endlToBr(surveyPage.description)}
                    </div>
                   
                    <div style={style.body}>
                        {Boolean(pluginsMap['google_plus']) &&
                        <div style={style.buttonWrapper}>
                            <Button  style={style.tealButton} onClick={()=>onConnect(pluginsMap['google_plus'])}>
                                {surveyPage.buttonLabel || t('Continue')}
                                <Icon style={style.syncIcon} name='random'></Icon>
                            </Button>
                        </div>
                        }
                    </div>

                    <SurveyButtons canSkip={true} onSkip={()=>onSubmit(null, false)} valid={!busy} inlineButtons={false} />
                    <div style={style.spacer} />
                </form>
                }
            </div>
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageSyncContacts);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageSyncContacts.js